import { FavClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiFavClient = new FavClient(defaultAxiosInstance)
